import React, { useState } from 'react';
import { Row, Col, FormGroup, FormControl, FormLabel, Form, Button, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from 'axios';
import cuteMonk1 from '../../assets/img/baolinPrivate/cute_monk1.png';
import cuteMonk2 from '../../assets/img/baolinPrivate/cute_monk2.png';

function NewAdminModal({ modal, setModal, refreshData }) {
    const MySwal = withReactContent(Swal);

    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState('');
    const [displayname, setDisplayname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    
    // State for error messages
    const [firstnameError, setFirstnameError] = useState(null);
    const [lastnameError, setLastnameError] = useState(null);
    const [emailError, setEmailError] = useState(null);
    const [phoneError, setPhoneError] = useState(null);
    const [displaynameError, setDisplaynameError] = useState(null);

    const validateForm = () => {
        let isValid = true;

        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!emailRegex.test(email)) {
            setEmailError("Invalid email format.");
            isValid = false;
        } else {
            setEmailError(null);
        }

        if (!firstname.trim()) {
            setFirstnameError("First name is required.");
            isValid = false;
        } else {
            setFirstnameError(null);
        }

        if (!lastname.trim()) {
            setLastnameError("Last name is required.");
            isValid = false;
        } else {
            setLastnameError(null);
        }

        if (!phone.trim()) {
            setPhoneError("Phone number is required.");
            isValid = false;
        } else {
            setPhoneError(null);
        }
        
        if (!displayname.trim()) {
            setDisplaynameError("Chinese Name / Dharma Name is required.");
            isValid = false;
        } else {
            setDisplaynameError(null);
        }

        return isValid;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validateForm()) {
            const adminData = {
                firstname,
                lastname,
                displayname,
                email,
                phone,
            };

            try {
                const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/admin/users`, adminData, { withCredentials: true });
                if (response.status === 200) {
                    await Swal.fire({
                        title: 'Success!',
                        text: 'Admin created successfully. An email with their random password has been sent.',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                    setModal(false);
                    if (refreshData) {
                        refreshData();
                    }
                    
                    // Reset form
                    setFirstname('');
                    setLastname('');
                    setDisplayname('');
                    setEmail('');
                    setPhone('');
                }
            } catch (error) {
                console.error('Error creating admin:', error);
                let errorMessage = 'An error occurred while creating the admin.';
                if (error.response?.data?.detail) {
                    errorMessage = error.response.data.detail;
                }
                await Swal.fire({
                    title: 'Error!',
                    text: errorMessage,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        }
    }

    return (
        <Modal
            className="modal-primary"
            onHide={() => setModal(!modal)}
            show={modal}
            size="lg">
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <p className="text-center mb-2 font-weight-bold">
                        <img src={cuteMonk1} alt="Logo" width="40" className="mr-3" />
                        添加管理員
                        <img src={cuteMonk2} alt="Logo" width="40" className="ml-3" />
                    </p>
                    <hr />
                    <Row>
                        <Col md={{ span: 10, offset: 1 }}>
                            <FormGroup>
                                <FormLabel>First Name <span className="text-danger">*</span></FormLabel>
                                <FormControl
                                    type="text"
                                    value={firstname}
                                    onChange={(event) => setFirstname(event.target.value)}
                                />
                                {firstnameError && <small className="text-danger">{firstnameError}</small>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={{ span: 10, offset: 1 }}>
                            <FormGroup>
                                <FormLabel>Last Name <span className="text-danger">*</span></FormLabel>
                                <FormControl
                                    type="text"
                                    value={lastname}
                                    onChange={(event) => setLastname(event.target.value)}
                                />
                                {lastnameError && <small className="text-danger">{lastnameError}</small>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={{ span: 10, offset: 1 }}>
                            <FormGroup>
                                <FormLabel>法号/中文名 (Dharma Name / Chinese Name) <span className="text-danger">*</span></FormLabel>
                                <FormControl
                                    type="text"
                                    value={displayname}
                                    onChange={(event) => setDisplayname(event.target.value)}
                                />
                                {displaynameError && <small className="text-danger">{displaynameError}</small>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={{ span: 10, offset: 1 }}>
                            <FormGroup>
                                <FormLabel>Phone Number <span className="text-danger">*</span></FormLabel>
                                <FormControl
                                    type="text"
                                    value={phone}
                                    onChange={(event) => setPhone(event.target.value)}
                                />
                                {phoneError && <small className="text-danger">{phoneError}</small>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={{ span: 10, offset: 1 }}>
                            <FormGroup>
                                <FormLabel>Email <span className="text-danger">*</span></FormLabel>
                                <FormControl
                                    type="email"
                                    value={email}
                                    onChange={(event) => setEmail(event.target.value)}
                                />
                                {emailError && <small className="text-danger">{emailError}</small>}
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setModal(false)}>
                    Cancel
                </Button>
                <Button variant="primary" type="submit" onClick={handleSubmit}>
                    Add Admin
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default NewAdminModal;
